/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import AppNavSearch from '../../../../components/appNav/AppNavSearch';
import Page from '../../../../applicationFrame/Page';
import { BodyMain } from '../../../../components/Text';

import SearchResults from './SearchResults';

// import FindGroupZeroState from './FindGroupZeroState';
import FindGroupNoResults from './FindGroupNoResults';
import GroupTitle from '../../../../features/GroupTitle';
import { TrackEvent } from '../../../../../utilities/UserMetrics';
import { ScrollAwareFixedHeader } from '../../../../components/ScrollAware';

const DEFAULT_QUERY = '*';

class Search extends React.Component {

  constructor(props) {
    super(props);

    this.onSubmitSearch = this.onSubmitSearch.bind(this);
    this.onCancelSearch = this.onCancelSearch.bind(this);

    this.state = {
      showZeroState: true,
      query: '',
    };
  }

  UNSAFE_componentWillMount() {
    this.props.onSubmitSearch(DEFAULT_QUERY, this.props.languageCode);
  }

  onSubmitSearch(query) {
    this.props.onSubmitSearch(query, this.props.languageCode);
    this.setState({
      showZeroState: false,
    });
  }

  onCancelSearch() {
    TrackEvent.groups.searchCanceled(this.state.showZeroState);
    this.props.onCancelSearch();
    this.props.onGoBack();
  }

  onClearField = () => {
    this.props.onSubmitSearch(DEFAULT_QUERY, this.props.languageCode);
  }

  render() {
    return (
      <Page>
        <ScrollAwareFixedHeader colorThemeName="profile">
          <AppNavSearch
            query={this.state.query}
            queryPlaceholder={this.props.queryPlaceholder}
            cancelSearch={this.onCancelSearch}
            submitSearch={this.onSubmitSearch}
            onChangeQuery={() => {}}
            onClearField={this.onClearField}
          />
        </ScrollAwareFixedHeader>

        <div className="bkgd-color-light-neutral">
          <SearchResults
            results={this.props.results}
            isSearching={this.props.isSearching}
            emptyContent={<FindGroupNoResults />}
            onSelectResult={this.props.onSelectResult}
            isDisabled={(groupId) => (this.props.disabledResults.find(id => id === groupId) >= 0)}
            renderResult={(groupId) => <BodyMain><GroupTitle groupId={groupId} withOrganizationName /></BodyMain>}
          />
        </div>
      </Page>
    );
  }
}
Search.propTypes = {
  queryPlaceholder: PropTypes.string.isRequired,
  results: PropTypes.array,
  disabledResults: PropTypes.array,
  isSearching: PropTypes.bool,
  onSelectResult: PropTypes.func,
  onCancelSearch: PropTypes.func,
  onSubmitSearch: PropTypes.func,
  onGoBack: PropTypes.func,
  languageCode: PropTypes.string,
};

export default Search;
